import {
    Dialog,
    DialogTitle,
    Stack,
    Typography,
    List,
    ListItemButton,
    ListItemText,
    ListItemIcon,
    Divider,
} from '@mui/material';
import { ChangeHistory, Message, BatchPrediction } from '@mui/icons-material';

function CommandPalette({
    open,
    onClose,
    row,
    onViewLogs,
    onMovement,
    onPredict,
    canViewLogs,
    canMovement,
    isModelReady,
}) {
    if (!row) return null;
    const run = (fn) => { onClose(); fn(); };

    return (
        <Dialog fullWidth maxWidth="xs" open={open} onClose={onClose}>
            <DialogTitle sx={{ borderBottom: "1px solid", borderColor: "divider", pb: 1.5 }}>
                <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                    <Typography variant="body2" fontWeight={600}>
                        {row.flightDesc} {row.sector}{" "}
                        {row.flightDate && new Date(row.flightDate).toLocaleDateString("en-GB")}
                    </Typography>
                </Stack>
            </DialogTitle>
            <List disablePadding>
                {canViewLogs && (
                    <ListItemButton onClick={() => run(() => onViewLogs(row))}>
                        <ListItemIcon><ChangeHistory /></ListItemIcon>
                        <ListItemText primary="Flight Logs" secondary="View change history" />
                    </ListItemButton>
                )}
                {canMovement && (
                    <ListItemButton onClick={() => run(() => onMovement(row._id))}>
                        <ListItemIcon><Message /></ListItemIcon>
                        <ListItemText primary="Movement" secondary="Open message dialog" />
                    </ListItemButton>
                )}
                {(canViewLogs || canMovement) && <Divider />}
                <ListItemButton onClick={() => run(() => onPredict(row))} disabled={!isModelReady}>
                    <ListItemIcon><BatchPrediction /></ListItemIcon>
                    <ListItemText
                        primary="Predict Delay"
                        secondary={isModelReady ? "Run ML prediction" : "Train model first in Delay Predictor"}
                    />
                </ListItemButton>
            </List>
        </Dialog>
    );
}

export default CommandPalette;
